import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
 ArrowUpRight,
 Calendar,
 Building2,
 BarChart3,
 CreditCard,
 Banknote,
 Users,
} from 'lucide-react';

const ACTIONS = [
 { label: 'Bookings', hint: 'Review marketplace orders', path: '/admin/bookings', Icon: Calendar },
 { label: 'Vendors', hint: 'Manage vendor accounts', path: '/admin/vendors', Icon: Building2 },
 { label: 'Clients', hint: 'Client directory', path: '/admin/clients', Icon: Users },
 { label: 'Payments', hint: 'Client booking charges', path: '/admin/payments', Icon: CreditCard },
 { label: 'Payouts', hint: 'Settle vendor balances', path: '/admin/vendor-payouts', Icon: Banknote },
 { label: 'Analytics', hint: 'Deeper platform insights', path: '/admin/analytics', Icon: BarChart3 },
];

const QuickActions = () => {
 const navigate = useNavigate();

 return (
 <div className="product-panel p-4 sm:p-5">
 <div className="mb-4">
 <h3 className="text-sm font-semibold text-ink">Quick actions</h3>
 <p className="text-xs text-ink-tertiary mt-0.5">Jump to common admin tasks</p>
 </div>
 <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
 {ACTIONS.map(({ label, hint, path, Icon }) => (
 <button
 key={path}
 type="button"
 onClick={() => navigate(path)}
 className="flex items-center gap-3 p-3 border border-border rounded-md hover:bg-surface-muted/70 transition-colors text-left group"
 >
 <div className="p-2 rounded-lg bg-surface-muted border border-border shrink-0">
 <Icon className="w-4 h-4 text-ink-secondary" />
 </div>
 <div className="min-w-0 flex-1">
 <p className="text-sm font-medium text-ink">{label}</p>
 <p className="text-[11px] text-ink-tertiary truncate">{hint}</p>
 </div>
 <ArrowUpRight className="w-4 h-4 text-gray-300 group-hover:text-gray-500 shrink-0" />
 </button>
 ))}
 </div>
 </div>
 );
};

export default QuickActions;
